export class ChildVaribles {
  public Key: string;
  public Name: string;
}
